<template>
    <tr class="prospectus-info-row">
        <td class="prospectus-info-td" :colspan="prospectusTypesWithListing.includes(lastSearchParams.ProspectusType) || lastSearchParams.ProspectusType === undefined ? 5 : 4">
            <div class="prospectus-info-div row">
                <div class="clearfix">
                    <div class="col">
                        <h4>{{prospectus.prospectusType == 5 ? conf.translations.prospectusName : conf.translations.prospectus}}</h4>
                        <template v-if="prospectus.prospectusType == 5">{{prospectus.prospectusName}}</template>
                        <ul v-else class="prospectus">
                            <li v-for="file in prospectus.prospectusFiles.concat().sort((a, b) => a.orderNumber - b.orderNumber)" :key="file.fileId">
                                <a @click.prevent="LoadFile(file)" :title="file.fileName" href="#">{{file.fileDisplayName}}</a><div v-show="IsFileLoading(file.fileId)" class="loading-spinner" />
                            </li>
                        </ul>
                    </div>
                    <template v-if="prospectus.acquiringCompany && prospectus.mergingCompanies.length > 0">
                        <div class="col right">
                            <h4>{{conf.translations.mergingcompanies}}</h4>
                            <ul>
                                <li v-for="company in prospectus.mergingCompanies" :key="company">
                                    {{company}}
                                </li>
                            </ul>
                        </div>
                        <div class="col right">
                            <h4>{{conf.translations.acquiringcompany}}</h4>
                            <ul>
                                <li>{{prospectus.acquiringCompany}}</li>
                            </ul>
                        </div>
                    </template>
                    <template v-if="prospectus.offeree && prospectus.offeror">
                        <div class="col right">
                            <h4>{{conf.translations.offeree}}</h4>
                            <ul>
                                <li>{{prospectus.offeree}}</li>
                            </ul>
                        </div>
                        <div class="col right">
                            <h4>{{conf.translations.offeror}}</h4>
                            <ul>
                                <li>{{prospectus.offeror}}</li>
                            </ul>
                        </div>
                    </template>
                    <template v-if="prospectus.acquiringCompany && prospectus.dividingCompany">
                        <div class="col right">
                            <h4>{{conf.translations.acquiringcompanies}}</h4>
                            <ul>
                                <li>{{prospectus.acquiringCompany}}</li>
                            </ul>
                        </div>
                        <div class="col right">
                            <h4>{{conf.translations.dividingcompany}}</h4>
                            <ul>
                                <li>{{prospectus.dividingCompany}}</li>
                            </ul>
                        </div>
                    </template>
                    <template v-if="prospectus.competentAuthoritysName && prospectus.recordNumber">
                        <div class="col right">
                            <h4>{{conf.translations.competentauthority}}</h4>
                            <ul>
                                <li>
                                    <a v-if="prospectus.competentAuthoritysWebAddress" :href="prospectus.competentAuthoritysWebAddress">{{prospectus.competentAuthoritysName}}</a>
                                    <template v-else>
                                        {{prospectus.competentAuthoritysName}}
                                    </template>
                                </li>
                            </ul>
                        </div>
                        <div class="col right">
                            <h4>{{conf.translations.recordnumber}}</h4>
                            <ul>
                                <li>{{prospectus.recordNumber}}</li>
                            </ul>
                        </div>
                        <div v-if="prospectus.prospectusType == 5" class="col right">
                            <h4>{{conf.translations.prospectusInfo}}</h4>
                            <ul>
                                <li>{{prospectus.prospectusInfo}}</li>
                            </ul>
                        </div>
                    </template>
                </div>
                <template v-if="prospectus.supplements && prospectus.supplements.length > 0">
                    <!-- <h5>{{conf.translations.supplements}}</h5>
                    <ul class="supplements">
                        <li v-for="supplement in prospectus.supplements" :key="supplement.fileId">
                            <a @click.prevent="LoadFile(supplement)" href="#" :title="supplement.fileName">{{supplement.fileDisplayName}}</a><div v-show="IsFileLoading(supplement.fileId)" class="loading-spinner" />
                        </li>
                    </ul> -->
                    <table class="supplements prospectus-item-info-table">
                      <thead>
                        <tr>
                          <td>{{conf.translations.supplements}}</td>
                          <td>{{conf.translations.approvalDate}}</td>
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="supplement in prospectus.supplements.concat().sort((a, b) => a.orderNumber - b.orderNumber)" :key="supplement.fileId">
                          <td>
                            <a @click.prevent="LoadFile(supplement)" href="#" :title="supplement.fileName">{{supplement.fileDisplayName}}</a><div v-show="IsFileLoading(supplement.fileId)" class="loading-spinner" />
                          </td>
                          <td>{{FormatDate(supplement.approvalDate)}}</td>
                        </tr>
                      </tbody>
                    </table>
                </template>
                <template v-if="prospectus.documentsIncorporatedByReference && prospectus.documentsIncorporatedByReference.length > 0">
                    <!-- <h5>{{conf.translations.documentsIncorporatedByReference}}</h5>
                    <ul class="documents-incorporated-by-reference">
                        <li v-for="doc in prospectus.documentsIncorporatedByReference" :key="doc.fileId">
                            <a @click.prevent="LoadFile(doc)" :title="doc.fileName" href="#">{{doc.fileDisplayName}}</a><div v-show="IsFileLoading(doc.fileId)" class="loading-spinner" />
                        </li>                        
                    </ul> -->
                    <table class="documentsIncorporatedByReference prospectus-item-info-table">
                      <thead>
                        <tr>
                          <td>{{conf.translations.documentsIncorporatedByReference}}</td>                          
                        </tr>
                      </thead>
                      <tbody>
                        <tr v-for="doc in prospectus.documentsIncorporatedByReference.concat().sort((a, b) => a.orderNumber - b.orderNumber)" :key="doc.fileId">
                          <td>
                            <a @click.prevent="LoadFile(doc)" href="#" :title="doc.fileName">{{doc.fileDisplayName}}</a><div v-show="IsFileLoading(doc.fileId)" class="loading-spinner" />
                          </td>                          
                        </tr>
                      </tbody>
                    </table>
                </template>
                <template v-if="prospectus.termSheetForBonds && prospectus.termSheetForBonds.length > 0">                    
                    <table class="term-sheet-for-bonds prospectus-item-info-table">
                        <thead>
                            <tr>
                                <td>{{conf.translations.termSheetForBonds}}</td>
                                <td>{{conf.translations.loanPeriod}}</td>
                                <td>{{conf.translations.basisOfInterest}}</td>
                                <td>{{conf.translations.listed}}</td>
                                <td>{{conf.translations.finalTerms}}</td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="sheet in prospectus.termSheetForBonds.concat().sort((a, b) => a.orderNumber - b.orderNumber)" :key="sheet.fileId">
                                <td>
                                    <a @click.prevent="LoadFile(sheet)" :title="sheet.fileName" href="#">{{sheet.fileDisplayName}}</a>
                                    <div v-show="IsFileLoading(sheet.fileId)" class="loading-spinner" />                 
                                </td>
                                <td>{{formatDateSpan(sheet.loanPeriodBegin, sheet.loanPeriodEnd)}}</td>
                                <td>{{sheet.basisOfInterest}}</td>
                                <td>{{YesNo(sheet.listed)}}</td>
                                <td>
                                    <a v-if="sheet.finalTermId != 0" @click.prevent="LoadFile({fileId: sheet.finalTermId, fileType: sheet.finalTermType})" :title="sheet.finalTermsName" href="#">{{sheet.finalTermsDisplayName}}</a>
                                    <div v-show="IsFileLoading(sheet.fileId)" class="loading-spinner" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </template>
            </div>
        </td>
    </tr>
</template>

<script>
    import { mapState, mapActions, mapGetters } from "vuex";

    export default {
        methods: {
            ...mapActions(["LoadFile"]),
            formatDateSpan(beginDate, endDate) {
                let output = "";
                if (beginDate)
                    output += this.FormatDate(beginDate) + " - ";
                if (endDate)
                    output += this.FormatDate(endDate);
                return output;
            }
        },
        props: {
            prospectus: {},
        },
        computed: {
            ...mapGetters(["LocaleString", "IsFileLoading", "YesNo", "FormatDate"]),
            ...mapState(["conf", "prospectusTypesWithListing", "lastSearchParams", "currentlyLoadingFiles"])
        }
    }
</script>

<style lang="scss" scoped>
</style>